document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.collection-read-more-section');
    if (!section) return;

    const wrapper = section.querySelector('.collection-description__inner');
    const button = section.querySelector('.collection-read-more-button');

    if (!wrapper || !button) return;

    let isOpen = false;

    const collapsedHeight = parseInt(wrapper.dataset.collapsed) || 120;

    // measure full height
    const fullHeight = wrapper.scrollHeight;

    if (fullHeight <= collapsedHeight) {
        button.style.display = 'none';
        return;
    }

    wrapper.style.height = collapsedHeight + 'px';

    button.addEventListener('click', function () {
        if (!isOpen) {
            wrapper.style.height = fullHeight + 'px';
            wrapper.classList.add('is-open');
            button.textContent = "Read Less";
        } else {
            wrapper.style.height = collapsedHeight + 'px';
            wrapper.classList.remove('is-open');
            button.textContent = "Read More";
        }
        isOpen = !isOpen;
    });
});
